module.exports = __webpack_public_path__ + "img/company.5da66052.svg";